import InfoIcon from '../../../assets/svg/info.svg';
import { useAuth } from '../../../lib/auth';
import { StatusPopupProps } from './props';
import { inferParkingModal } from './utils/inferTypes';

import { useTranslation } from 'react-i18next';
import { useLatestEventSlice } from '../../../slices/useLatestEventSlice';
import { useParkingBookingSlice } from '../../../slices/useParkingBookingSlice';

export const StatusPopup = ({
  parking,
  userSubscriptions,
}: StatusPopupProps) => {
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const { latestEvent } = useLatestEventSlice();
  const { parkingBookings } = useParkingBookingSlice();

  let selectedModalType = inferParkingModal(
    currentUser,
    t,
    userSubscriptions,
    latestEvent,
    parkingBookings,
    parking
  );

  if (!selectedModalType) {
    return null;
  }

  return (
    <div
      className={`absolute bg-white z-status-popup border border-black  left-[36px] right-[36px] top-[32px] shadow-2xl rounded-lg flex p-4`}
    >
      <div className="ml-4 flex flex-col gap-2">
        <div className="flex flex-row items-center gap-2">
          <div className="w-8 h-8 xxs:w-12 xxs:h-12">
            <InfoIcon />
          </div>
          <div className={`text-black text-sm xxs:text-md font-bold `}>
            {selectedModalType.title}
          </div>
        </div>
        <div
          className="text-xs xxs:text-sm"
          dangerouslySetInnerHTML={{ __html: selectedModalType.description }}
        />
      </div>

      {/* {selectedModalType.type === 'unavailable' && (
        <Button
          Icon={CheckIcon}
          loading={isLoadingRewardCreate}
          onClick={() => setHideModal(true)}
          type="primary"
        >
          Ok
        </Button>
      )} */}
    </div>
  );
};
